import { navigate } from "lib/routes/navigate"

export function goToRegime(regime) {
    if (regime?.regimeId) {
        navigate(`/app/schedules?id=${regime.regimeId}`)
    }
}
